import React, { useRef, useState } from "react";
import "../../Css/HomePage/HomeTestimonial.css";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// import "./styles.css";

// import required modules
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { IoMdStar } from "react-icons/io";
import testimonialProfile from "../../Images/testimonial01.jpg";
import { Fade } from "react-awesome-reveal";

const HomeTestimonial = () => {
  return (
    <>
    <Fade>
      <section className="home-testimonial-section" id="testimonials">
        <div className="container">
          <div className="home-testimonial-section-con">
          <div className="home-testimonial-section-main-con">
            <div className="home-testimonial-section-heading-con">
              <h2>Testimonials</h2>
              <h3>What Client's Say?</h3>
              <div class="line"></div>
            </div>
            <div className="home-testimonial-section-swiper-main-con">
              <Swiper
                spaceBetween={30}
                centeredSlides={true}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                pagination={{
                  clickable: true,
                }}
                navigation={true}
                modules={[Autoplay, Pagination, Navigation]}
                className="mySwiper"
              >
                <SwiperSlide>
                  <div className="home-testimonial-section-swiper-details-main-con">
                    <div className="home-testimonial-section-swiper-details-con">
                      <p>
                      Lorem ipsum dolor sit amet consectetur adipisicing elit. Excepturi ab, incidunt iusto, beatae expedita hic minima laborum alias esse quae, ipsam consectetur nesciunt quia? Cumque nulla necessitatibus aperiam laborum quod.
                      </p>
                      <div className="home-testimonial-section-profile-setails-main-con">
                        <div className="home-testimonial-section-profile-image-con">
                          <img src={testimonialProfile} alt="testimonialProfile"/>
                        </div>
                        <div className="home-testimonial-section-profile-details">
                          <div className="home-testimonial-section-profile-details-start">
                            <IoMdStar />
                            <IoMdStar />
                            <IoMdStar />
                            <IoMdStar />
                            <IoMdStar />
                          </div>
                          <h4>Rahul Shejul </h4>
                          {/* <h5>Guest review</h5> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
          </div>
        </div>
      </section>
      </Fade>
    </>
  );
};

export default HomeTestimonial;
